import React from 'react';
import { DisplayPicture, PersonalInfoCard, PersonalInfoSection } from '../styled/PersonalInfo.styled';
import Typewriter from 'typewriter-effect';
import { personalInformationData } from '../../data';

const PersonalInfo = () => {
    return (
        <>
                <PersonalInfoSection>
                    <h4>Personal information</h4>
                    <PersonalInfoCard>
                        <DisplayPicture>
                            <img src={personalInformationData.image} alt="" />
                        </DisplayPicture>
                        <Typewriter
                            options={{
                                strings: [personalInformationData.name],
                                autoStart: true,
                                loop: true,
                                pauseFor: 2000,
                            }}
                        />
                        <h3>{personalInformationData.title}</h3>
                        <p>{personalInformationData.details}</p>
                    </PersonalInfoCard>
                </PersonalInfoSection>
        </>
    );
};

export default PersonalInfo;